var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { QueryList } from '@angular/core';
import { Report, ReportCreation, ReportSection, ReportSectionEnum } from '../../../models/measure/report';
import { MeasureSearchCriteria } from '../../../models/measure/measure-search-criteria';
import { MeasureService } from '../../services/measure/measure.service';
import { UserService } from '../../services/user.service';
import { CampaignService } from '../../services/campaign/campaign.service';
import { InfluencerGroupsService } from '../influencer-groups/influencer-groups.service';
import { ReferenceDataService } from '../../services/reference-data/reference-data.service';
import { CommonConstant, BestPerformingInfluencerSortBy } from '../../app.constants';
import { TranslateService } from '@ngx-translate/core';
import { AchooPopupComponent } from '../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../services/modal/modal.service';
import * as Sentry from '@sentry/browser';
import { MeasureModulesSelectionComponent } from './measure-modules-selection/measure-modules-selection.component';
import { Project } from '../../../models/project/project';
import { ObjectUtils } from '../../utils/object.utils';
import { MeasureBreadcumbComponent } from './measure-breadcumb/measure-breadcumb.component';
import { DateUtils } from '../../utils/date.utils';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { PdfViewerService } from '../pdf-viewer/pdf-viewer.service';
import { PdfExportService } from '../../services/export-pdf/pdf-export.service';
import { AbstractAchooComponent } from '../abstract-achoo.component';
import { ActionSource, ActivePages, EventTrackerService, Page, TargetType, UserActionType } from '../../services/event-tracker/event-tracker.service';
import { Observable } from 'rxjs/Observable';
import { DateRange } from '../../../models/date-range';
import { MeasureReportTimeline } from './measure-setting/measure-setting.component';
import { NgbDateUtils } from '../../utils/ngb-date.utils';
import { MeasureModuleDropdownComponent } from './measure-module-dropdown/measure-module-dropdown.component';
import { MeasurePdfExportComponent } from './measure-pdf-export/measure-pdf-export.component';
var MeasureComponent = /** @class */ (function (_super) {
    __extends(MeasureComponent, _super);
    function MeasureComponent(measureService, campaignService, influencerGroupService, referenceDataService, translate, userService, modalService, router, route, location, pdfViewerService, pdfService, eventTracker) {
        var _this = _super.call(this, userService) || this;
        _this.measureService = measureService;
        _this.campaignService = campaignService;
        _this.influencerGroupService = influencerGroupService;
        _this.referenceDataService = referenceDataService;
        _this.translate = translate;
        _this.userService = userService;
        _this.modalService = modalService;
        _this.router = router;
        _this.route = route;
        _this.location = location;
        _this.pdfViewerService = pdfViewerService;
        _this.pdfService = pdfService;
        _this.eventTracker = eventTracker;
        _this.reportData = {};
        _this.reportList = [];
        _this.selectedProject = new Project();
        // the flag is used to know whether the user is creating or editing a report or in read only mode
        _this.editingReportMode = false;
        // this flag use to know when the filter is open or close. Default is open
        _this.isFilterShow = true;
        // flag to indicate whether show or hide module exporting
        _this.showExportingModule = false;
        /**
         * reference data for filter box
         */
        _this.campaignList = [];
        _this.listProjectOfAdvertiser = [];
        _this.influencerGroups = [];
        _this.platformList = [];
        _this.countryList = [];
        _this.reportCriteria = new MeasureSearchCriteria();
        /**
         * list all of supported module
         */
        _this.moduleList = [];
        /**
         * selected module Ids which are generated in report content
         */
        _this.selectedModuleIds = [];
        /**
         * selected module Ids which are generated in report content
         */
        _this.listModuleForPdf = [];
        _this.roiIndexMapping = new Map();
        _this.oonaIndexMapping = new Map();
        _this.interactionIndexMapping = new Map();
        /**
         * list module Ids which are selecting in list supported modules
         */
        _this.selectingModuleItems = [];
        // show mwssage when select project without mentions
        _this.selectedProjectWithoutMention = false;
        // number of post included into pdf report
        _this.numberOfPostInOnnaPdf = CommonConstant.MAX_ITEM_PER_PAGE_REPORT;
        _this.numberOfPostInRoiPdf = CommonConstant.MAX_ITEM_PER_PAGE_REPORT;
        _this.numberOfPostInInteractionPdf = CommonConstant.MAX_ITEM_PER_PAGE_REPORT;
        _this.moduleArr = [];
        _this.reportCriteria.company_id = _this.userService.getCompanyId();
        _this.reportCriteria.period = _this.getDefaultDateRange();
        return _this;
    }
    MeasureComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            var formatedParams = {};
            Object.keys(params).forEach(function (key) {
                var rawValue = params[key];
                if (isNaN(rawValue)) {
                    formatedParams[key] = rawValue;
                }
                else {
                    formatedParams[key] = Number(rawValue);
                }
            });
            _this.initializeCriteria = formatedParams;
            _this.initializeFilterCriteria();
        });
        _super.prototype.ngOnInit.call(this);
        // load list supported platforms and countries
        var referenceData = this.referenceDataService.referenceData;
        this.countryList = referenceData.countries.map(function (country) { return ({
            id: country.id,
            name: country.name
        }); });
        this.platformList = referenceData.platforms;
        this.measureService.loadListModules().subscribe(function (res) {
            _this.moduleList = res;
        });
        this.selectedBestPerformingInfluencerOrder = BestPerformingInfluencerSortBy.REACH;
        this.reportCriteria.orderBy = BestPerformingInfluencerSortBy.REACH;
    };
    MeasureComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        // unscribe all active subcriptions
        this.cancelPendingRequest();
    };
    // The callback when switching account
    MeasureComponent.prototype.companyChangeCallback = function (companyId) {
        if (this.editingReportMode) {
            this.modalService.openInCenter(this.warningWhenSwitchingAccountInEditMode);
            return;
        }
        // cancel all pending request
        this.cancelPendingRequest();
        // clear the previous data
        this.resetReportData();
        // reset selecting module item list
        this.selectingModuleItems = [];
        // update activeAccount param
        this.initializeCriteria.activeAccount = companyId;
        this.reportCriteria.company_id = companyId;
        // load list existing reports
        this.loadListReports(companyId, this.initializeCriteria.reportId, true);
        // load list existing project of advertiser
        this.reloadProjectAndCampaign(companyId);
    };
    MeasureComponent.prototype.reloadProjectAndCampaign = function (companyId) {
        var _this = this;
        Observable.forkJoin(this.userService.getAllProjectOfAdvertiser(), this.campaignService.getCampaignFullListForCompany(companyId, false), this.campaignService.getCampaignFullListForCompany(companyId, true), this.influencerGroupService.getInfluencerGroupShortList(companyId)).subscribe(function (res) {
            // update list campaign and project by current companyId
            if (res[0]) {
                _this.updateProjectSelection(res[0].data);
            }
            if (res[1] && Array.isArray(res[1].campaigns)) {
                _this.campaignList = res[1].campaigns;
            }
            if (res[2] && Array.isArray(res[2].campaigns)) {
                _this.campaignList = _this.campaignList.concat(res[2].campaigns);
            }
            _this.influencerGroups = res[3] ? res[3].map(function (group) { return ({
                id: group.id,
                name: group.name
            }); }) : [];
            // not allow to render measure for free user
            if (_this.userService.isFreeUser() && !_this.userService.isAdmin) {
                return;
            }
            // update current project and campaign criteria
            // using the resquest params if existing and belonging to current company
            // default using the first project
            var initializedProjectId = _this.listProjectOfAdvertiser.length > 1 ? _this.listProjectOfAdvertiser[1].id : undefined;
            var initializedCampaignId = _this.campaignList.length > 0 ? _this.campaignList[0].id : undefined;
            if (_this.haveValidProjectParam(_this.initializeCriteria)) {
                initializedProjectId = _this.initializeCriteria.project_id;
                _this.reportCriteria.project_id = initializedProjectId;
                _this.reportCriteria.campaign_id = null;
                _this.reportCriteria.influencerGroup = null;
                // reset unused params
                _this.initializeCriteria.campaign_id = null;
                _this.initializeCriteria.influencerGroup = null;
            }
            else if (_this.haveValidCampaignParam(_this.initializeCriteria)) {
                initializedCampaignId = _this.initializeCriteria.campaign_id;
                _this.reportCriteria.project_id = null;
                _this.reportCriteria.campaign_id = initializedCampaignId;
                _this.reportCriteria.influencerGroup = null;
                // reset unused params
                _this.initializeCriteria.project_id = null;
                _this.initializeCriteria.influencerGroup = null;
            }
            else if (_this.haveValidGroupParam(_this.initializeCriteria)) {
                _this.reportCriteria.project_id = null;
                _this.reportCriteria.campaign_id = null;
                _this.reportCriteria.influencerGroup = _this.initializeCriteria.influencerGroup;
                // reset unused params
                _this.initializeCriteria.project_id = null;
                _this.initializeCriteria.campaign_id = null;
            }
            else {
                _this.reportCriteria.project_id = initializedProjectId;
                _this.reportCriteria.campaign_id = null;
                _this.reportCriteria.influencerGroup = null;
                // reset unused params
                _this.initializeCriteria.project_id = null;
                _this.initializeCriteria.campaign_id = null;
                _this.initializeCriteria.influencerGroup = null;
            }
            // track event open report to Segment
            _this.viewReportTracker(_this.selectedReport, _this.listProjectOfAdvertiser.find(function (p) { return p.id === initializedProjectId; }));
            // generate the default report by the default project id
            _this.generateReportByCriteria(_this.reportCriteria);
        });
    };
    /**
     * validate the campaignId in request parameters is valid and belonged to current company
     * @param initializeCriteria
     * @returns {boolean}
     */
    MeasureComponent.prototype.haveValidCampaignParam = function (initializeCriteria) {
        if (!initializeCriteria || !initializeCriteria.campaign_id || (initializeCriteria.campaign_id <= 0)) {
            return false;
        }
        return this.campaignList.filter(function (p) { return p.id === initializeCriteria.campaign_id; }).length > 0;
    };
    /**
     * validate the influencerGroup in request parameters is valid and belonged to current company
     * @param initializeCriteria
     * @returns {boolean}
     */
    MeasureComponent.prototype.haveValidGroupParam = function (initializeCriteria) {
        if (!initializeCriteria || !initializeCriteria.influencerGroup || (initializeCriteria.influencerGroup <= 0)) {
            return false;
        }
        return this.influencerGroups.filter(function (p) { return p.id === initializeCriteria.influencerGroup; }).length > 0;
    };
    /**
     * validate the projectId in request parameters is valid and belonged to current company
     * @param initializeCriteria
     * @returns {boolean}
     */
    MeasureComponent.prototype.haveValidProjectParam = function (initializeCriteria) {
        if (!initializeCriteria || !initializeCriteria.project_id || (initializeCriteria.project_id <= 0)) {
            return false;
        }
        return this.listProjectOfAdvertiser.filter(function (p) { return p.id === initializeCriteria.project_id; }).length > 0;
    };
    MeasureComponent.prototype.loadListProject = function () {
        var _this = this;
        this.userService.getAllProjectOfAdvertiser().subscribe(function (res) {
            _this.updateProjectSelection(res.data);
            // not allow to load measure by project for free user
            if (!_this.userService.isFreeUser() || _this.userService.isAdmin) {
                // track event open report to Segment
                _this.viewReportTracker(_this.selectedReport, _this.listProjectOfAdvertiser[1]);
                // generate the default report by the default project id
                _this.generateReportByCriteria(_this.reportCriteria);
            }
        });
    };
    MeasureComponent.prototype.updateProjectSelection = function (listProject) {
        this.listProjectOfAdvertiser = [{
                id: 0,
                name: this.translate.instant('measure.create_new_project')
            }];
        if (Array.isArray(listProject)) {
            (_a = this.listProjectOfAdvertiser).push.apply(_a, listProject);
        }
        var _a;
    };
    MeasureComponent.prototype.loadListReports = function (companyId, selectedReportId, reloadReportContent) {
        var _this = this;
        // load list existing reports
        this.measureService.getListMeasureReport(companyId).subscribe(function (reports) {
            _this.reportList = _this.buildReportList(reports, selectedReportId, reloadReportContent);
        });
    };
    MeasureComponent.prototype.createNewReport = function (e) {
        // enable flag to set user in editable mode
        this.editingReportMode = true;
        // set default value of new report
        var newReport = new Report();
        newReport.sectionList = [];
        // set new report as selected report
        this.onSelectExistingReport(newReport);
        // update position of arrow
        this.measureBreadcumb.updateArrowPosition('', CommonConstant.MAX_LENGTH_REPORT_NAME_FIELD);
        // set focus on edit field
        this.measureBreadcumb.reportNameInputField.setFocus();
        // update default selected module on dropdown
        this.moduleDropDown.initializeSelectedModuleForNewReport();
    };
    MeasureComponent.prototype.editReport = function (e) {
        this.editingReportMode = true;
        // set focus on edit field
        this.measureBreadcumb.reportNameInputField.setFocus();
    };
    MeasureComponent.prototype.showWarningBeforeCancelEditReport = function () {
        this.modalService.openInCenter(this.warningCancelReportDialog);
    };
    MeasureComponent.prototype.cancelEditReport = function () {
        // in case edit, reload the previous report after cancelling
        // in case create new, reload list report
        if (this.selectedReport.id > 0) {
            this.loadListReports(this.userService.getCompanyId(), this.selectedReport.id, true);
        }
        else {
            this.loadListReports(this.userService.getCompanyId(), undefined, true);
        }
        this.exitWithoutChanging();
    };
    MeasureComponent.prototype.createOrUpdateReport = function (report, showNotification) {
        var _this = this;
        if (showNotification === void 0) { showNotification = true; }
        // stop processing if no selected report
        if (!report) {
            return;
        }
        // not allow to update default report
        if (report.is_default_report) {
            this.modalService.open(this.notificationWarningEditDefaultReport, undefined, true);
            return;
        }
        // disable edit report
        this.editingReportMode = false;
        // Create new report object
        var saveReport = new ReportCreation();
        saveReport.id = report.id;
        saveReport.reportName = report.name;
        saveReport.companyId = this.userService.getCompanyId();
        // Add available sections to new report
        this.selectedModuleIds.forEach(function (moduleId, index) {
            var module = report.sectionList.find(function (m) { return m.id === moduleId; });
            if (module) {
                module.section_id = module.id;
                module.position = index;
                saveReport.sections.push(module);
            }
        });
        // Call create report API with new report params
        this.measureService.createOrUpdateReport(saveReport).subscribe(
        // Success
        function (res) {
            // reset selected group to default after saving report
            _this.moduleDropDown.selectedGroupId = CommonConstant.ALL_MODULES_ID;
            if (showNotification) {
                _this.notificationCreateOrUpdateReportMessage = _this.getNotificationMessageForCreation(report);
                // show notification
                _this.modalService.open(_this.notificationCreateOrUpdateReport, undefined, true);
            }
            // track event to Segment
            _this.eventTracker.trackUserAction(UserActionType.ACTION, Page.REPORT, undefined, __assign({ action: saveReport.id > 0 ? UserActionType.UPDATE : UserActionType.CREATE, source: ActionSource.PAGE }, saveReport), {
                id: res.data.id,
                name: res.data.report_name
            }, {
                type: ActivePages.MEASURE,
                name: res.data.report_name,
                id: res.data.id
            });
            // load list report
            _this.loadListReports(_this.userService.getCompanyId(), res.data.id);
        }, 
        // Error
        function (error) {
            _this.editingReportMode = true;
            _this.warningMessage = error.error.message;
            _this.modalService.open(_this.warningMeasureDialog, undefined, true);
        });
    };
    /**
     * get notification message after saving report
     * @param report
     * @returns {string | any}
     */
    MeasureComponent.prototype.getNotificationMessageForCreation = function (report) {
        if (!report) {
            // return empty string if no selected report
            return '';
        }
        else if (report.id > 0) {
            return this.translate.instant('measure.update_report_notification', { reportName: report.name });
        }
        else {
            return this.translate.instant('measure.create_new_report_notification');
        }
    };
    MeasureComponent.prototype.onSelectExistingReport = function (selectedReport) {
        this.selectedReport = selectedReport;
        this.selectedModuleIds = this.selectedReport.sectionList.map(function (section) { return section.id; });
        this.generateReportByCriteria(this.reportCriteria);
        this.trackMeasureView(selectedReport, this.reportCriteria);
    };
    MeasureComponent.prototype.getTrackerReportCriteriaTarget = function (reportFilterCriteria) {
        var targetId, targetName, targetType;
        if (reportFilterCriteria.project_id) {
            var project = this.listProjectOfAdvertiser.find(function (p) { return p.id === reportFilterCriteria.project_id; });
            if (project) {
                targetId = project.id;
                targetName = project.name;
                targetType = 'Project';
            }
        }
        else if (reportFilterCriteria.influencerGroup) {
            var inflGroup = this.influencerGroups.find(function (infl) { return infl.id === reportFilterCriteria.influencerGroup; });
            if (inflGroup) {
                targetId = inflGroup.id;
                targetName = inflGroup.name;
                targetType = 'Influencer Group';
            }
        }
        else if (reportFilterCriteria.campaign_id) {
            var campaign = this.campaignList.find(function (camp) { return camp.id === reportFilterCriteria.campaign_id; });
            if (campaign) {
                targetId = campaign.id;
                targetName = campaign.name;
                targetType = 'Campaign';
            }
        }
        return {
            targetId: targetId,
            targetName: targetName,
            targetType: targetType
        };
    };
    MeasureComponent.prototype.trackMeasureView = function (selectReport, reportFilterCriteria) {
        var targetId, targetName, targetType;
        var target = this.getTrackerReportCriteriaTarget(reportFilterCriteria);
        targetId = target.targetId,
            targetName = target.targetName,
            targetType = target.targetType,
            this.eventTracker.trackUserAction(UserActionType.VIEW, Page.MEASURE, {
                id: targetId,
                name: targetName,
                type: targetType
            }, undefined, {
                id: selectReport.id,
                name: selectReport.name
            }, {
                type: ActivePages.MEASURE,
                name: selectReport.name,
                id: selectReport.id
            });
    };
    MeasureComponent.prototype.onCreateOrEditProject = function (project) {
        this.selectedProject = ObjectUtils.deepClone(project);
        this.statusBottomBar = 'active';
    };
    MeasureComponent.prototype.onChangeActiveModuleList = function (evt) {
        var currentSelectingModuleIds = this.selectingModuleItems.map(function (sm) { return sm.id; });
        var newActiveModules = evt.filter(function (e) { return currentSelectingModuleIds.indexOf(e.id) < 0; });
        this.selectedModuleIds = evt.map(function (m) { return m.id; });
        this.updateModuleList(newActiveModules);
        this.selectingModuleItems = evt;
    };
    /**
     * execute the latest update of module list. Call when dropdown is closed
     * @param e
     */
    MeasureComponent.prototype.updateModuleList = function (selectingModuleItems) {
        var _this = this;
        if (selectingModuleItems.length === 0) {
            return;
        }
        // not allow to edit a default report
        if (this.selectedReport && this.selectedReport.is_default_report) {
            this.modalService.open(this.notificationWarningEditDefaultReport, undefined, true);
            return;
        }
        // update report content
        selectingModuleItems.forEach(function (module) {
            // add new module if this module is not selected
            if (!_this.isExistingModule(_this.selectedReport, module)) {
                // create a new report section and add it to selected report
                var newSection = new ReportSection();
                newSection.id = module.id;
                newSection.section_id = module.id;
                newSection.section_template = module.template;
                newSection.position = _this.findTheMaximunPositionOfModule(_this.selectedReport);
                _this.selectedReport.sectionList.push(newSection);
                // generate report content for new section
                var currentCriteria = _this.reportCriteria;
                if (_this.isValidCriteriaToGenerateReport(currentCriteria)) {
                    // fulfill the current criteria before peforming async load
                    var fulfillCurrentCriteria = _this.fulfillCriteria(currentCriteria);
                    // load data and generate report content of new module
                    _this.generateReportBySection(module.id, fulfillCurrentCriteria);
                }
            }
        });
        // track event by segment
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.REPORT, {
            type: TargetType.MODULES
        }, {
            action: UserActionType.SELECTION,
            source: ActionSource.PAGE,
            selectedModules: selectingModuleItems.map(function (item) { return ({
                id: item.id,
                name: item.name
            }); })
        }, {
            id: this.selectedReport.id,
            name: this.selectedReport.name
        }, {
            type: ActivePages.MEASURE,
            name: this.selectedReport.name,
            id: this.selectedReport.id
        });
    };
    Object.defineProperty(MeasureComponent.prototype, "activeReport", {
        get: function () {
            return this.selectedReport || new Report();
        },
        enumerable: true,
        configurable: true
    });
    MeasureComponent.prototype.getReportDataById = function (section) {
        var sectionData = Object.getOwnPropertyDescriptor(this.reportData, section);
        return sectionData ? sectionData.value.data : undefined;
    };
    MeasureComponent.prototype.getReportTitleById = function (section) {
        var sectionTitle = Object.getOwnPropertyDescriptor(this.reportData, section);
        return sectionTitle ? sectionTitle.value.title : undefined;
    };
    MeasureComponent.prototype.isActiveBottomBar = function () {
        return this.statusBottomBar === 'active';
    };
    MeasureComponent.prototype.isInactiveBottomBar = function () {
        return !this.statusBottomBar || this.statusBottomBar === 'inactive';
    };
    MeasureComponent.prototype.onChangeReportPeriod = function (selectedPeriod) {
        if (!selectedPeriod) {
            return;
        }
        // update criteria
        this.reportCriteria.period = DateRange.buildDateRangeWithBorder(selectedPeriod.fromDate, selectedPeriod.toDate);
        // update report content
        this.generateReportByCriteria(this.reportCriteria);
        // track event by segment
        this.eventTracker.trackUserAction(UserActionType.ACTION, Page.MEASURE, {
            id: selectedPeriod.name,
            name: selectedPeriod.name,
            type: TargetType.DATE_RANGE
        }, {
            action: UserActionType.TOGGLE,
            source: ActionSource.PAGE,
        }, {
            id: this.selectedReport.id,
            name: this.selectedReport.name
        }, {
            type: ActivePages.MEASURE,
            name: this.selectedReport.name,
            id: this.selectedReport.id
        });
    };
    MeasureComponent.prototype.deleteExistingReport = function (selectedReport) {
        var _this = this;
        this.measureService.deleteReport(selectedReport.id, this.userService.getCompanyId()).subscribe(function (res) {
            // reload list report
            _this.loadListReports(_this.userService.getCompanyId());
            // track event by segment
            _this.eventTracker.trackUserAction(UserActionType.ACTION, Page.REPORT, {
                id: selectedReport.id,
                name: selectedReport.name,
                type: TargetType.REPORT
            }, {
                action: UserActionType.DELETE,
                source: ActionSource.PAGE,
            }, {
                id: _this.selectedReport.id,
                name: _this.selectedReport.name
            }, {
                type: ActivePages.MEASURE,
                name: _this.selectedReport.name,
                id: _this.selectedReport.id
            });
        });
    };
    MeasureComponent.prototype.initializeFilterCriteria = function () {
        this.preCheckInitializeCriteria();
        this.reportCriteria = new MeasureSearchCriteria();
        this.reportCriteria = Object.assign({}, this.reportCriteria, this.initializeCriteria);
        if (this.initializeCriteria.from && this.initializeCriteria.to) {
            var selectedDateRange = new DateRange();
            selectedDateRange.startDate = this.initializeCriteria.from;
            selectedDateRange.endDate = this.initializeCriteria.to;
            this.reportCriteria.period = selectedDateRange;
        }
        else {
            this.reportCriteria.period = this.getDefaultDateRange();
        }
        if (this.initializeCriteria.roi_posts) {
            this.numberOfPostInRoiPdf = this.initializeCriteria.roi_posts;
        }
        if (this.initializeCriteria.interaction_posts) {
            this.numberOfPostInInteractionPdf = this.initializeCriteria.interaction_posts;
        }
        if (this.initializeCriteria.benchmark_posts) {
            this.numberOfPostInOnnaPdf = this.initializeCriteria.benchmark_posts;
        }
        if (this.initializeCriteria.active_bp) {
            this.activeBenchmarkPerformance = Number(this.initializeCriteria.active_bp);
        }
        if (this.initializeCriteria.active_co) {
            this.activeChannelOpportunity = Number(this.initializeCriteria.active_co);
        }
        if (this.initializeCriteria.removed_ti) {
            this.removedTopicInsights = this.initializeCriteria.removed_ti.split(',');
        }
        else {
            this.removedTopicInsights = [];
        }
    };
    MeasureComponent.prototype.preCheckInitializeCriteria = function () {
        if (!this.initializeCriteria.from || !this.initializeCriteria.to) {
            return;
        }
        var initalizedFromDate = new Date(this.initializeCriteria.from);
        var initalizedToDate = new Date(this.initializeCriteria.to);
        var today = DateUtils.now();
        if (!DateUtils.isValidDate(initalizedFromDate) || !DateUtils.isValidDate(initalizedToDate) ||
            DateUtils.after(initalizedFromDate, today) || DateUtils.after(initalizedFromDate, initalizedToDate)) {
            delete this.initializeCriteria.from;
            delete this.initializeCriteria.to;
        }
        else if (DateUtils.after(initalizedToDate, today)) {
            this.initializeCriteria.to = DateUtils.convertDateToString(today.getTime(), 'yyyy-MM-dd');
        }
    };
    MeasureComponent.prototype.onClearFilter = function () {
        var dateRange = this.reportCriteria.period;
        this.reportCriteria = new MeasureSearchCriteria();
        this.reportCriteria.period = dateRange;
    };
    MeasureComponent.prototype.onChangeCriteria = function (criteria) {
        // update local criteria
        this.reportCriteria = criteria;
        // re-generate report
        this.generateReportByCriteria(criteria);
    };
    MeasureComponent.prototype.updateSupportLink = function (criteria) {
        // not update url while exporting pdf
        if (this.pdfService.exportingPdf) {
            return;
        }
        var cloneCriteria = Object.assign({}, criteria, {
            activeAccount: this.userService.getCompanyId(),
            reportId: this.selectedReport && this.selectedReport.id,
            period: null,
            date: null,
            from: criteria.period ? criteria.period.startDate : null,
            to: criteria.period ? criteria.period.endDate : null,
            benchmark_posts: this.numberOfPostInOnnaPdf,
            interaction_posts: this.numberOfPostInInteractionPdf,
            roi_posts: this.numberOfPostInRoiPdf,
            active_bp: this.activeBenchmarkPerformance,
            active_co: this.activeChannelOpportunity,
            removed_ti: this.removedTopicInsights ? this.removedTopicInsights.join(',') : null
        });
        // keep track report Id
        this.initializeCriteria.reportId = cloneCriteria.reportId;
        var url = this.router
            .createUrlTree(['/measure'], { queryParams: cloneCriteria })
            .toString();
        this.location.go(url);
    };
    MeasureComponent.prototype.generateReportByCriteria = function (criteria, isBestPerformingInfluencerSorting) {
        var _this = this;
        this.moduleArr = [];
        // update link
        this.updateSupportLink(this.reportCriteria);
        // cancel all pending request
        this.cancelPendingRequest();
        if (!isBestPerformingInfluencerSorting) {
            // clear the previous data
            this.resetReportData();
        }
        // check the validation of criteria
        if (!this.isValidCriteriaToGenerateReport(criteria)) {
            // criteria invalid because report is not loaded yet. Don't need to report Sentry
            if (!this.selectedReport) {
                return;
            }
            this.showWarningNotification();
            // Report to Sentry
            Sentry.captureException(new Error(this.notificationContent));
            // stop generating if the no filter or no selected report
            return;
        }
        // fulfill the missing criteria
        var fulfillCriteria = this.fulfillCriteria(criteria);
        // perform report generation for each section
        this.selectedReport.sectionList.forEach(function (section) {
            _this.generateReportBySection(section.id, fulfillCriteria);
        });
    };
    MeasureComponent.prototype.closeModal = function () {
        this.modalService.close();
    };
    MeasureComponent.prototype.showWarningNotification = function () {
        this.notificationContent = this.translate.instant('measure.notification');
        this.modalService.open(this.notificationMeasure, undefined, true);
    };
    MeasureComponent.prototype.exitWithoutChanging = function () {
        var originalModuleIds = this.selectedReport.sectionList.map(function (s) { return s.id; });
        this.moduleDropDown.availableModuleList = this.moduleList.filter(function (am) { return originalModuleIds.indexOf(am.id) >= 0; })
            .map(function (m) { return Object.assign({}, m, {
            isActive: true
        }); });
        this.moduleDropDown.selectedGroupId = CommonConstant.ALL_MODULES_ID;
        this.closeModal();
        this.editingReportMode = false;
    };
    MeasureComponent.prototype.exitEditReport = function () {
        this.closeModal();
        this.editingReportMode = false;
        this.moduleDropDown.selectedGroupId = CommonConstant.ALL_MODULES_ID;
        this.companyChangeCallback(this.userService.getCompanyId());
    };
    MeasureComponent.prototype.onCloseBottomBar = function (data) {
        var _this = this;
        if (data.isReloadList) {
            this.userService.getAllProjectOfAdvertiser().subscribe(function (res) {
                _this.listProjectOfAdvertiser = [{
                        id: 0,
                        name: _this.translate.instant('measure.create_new_project')
                    }];
                (_a = _this.listProjectOfAdvertiser).push.apply(_a, res.data);
                if (data.isCreatedNew) {
                    // set the new project to be default
                    _this.reportCriteria.project_id = data.projectId;
                    _this.generateReportByCriteria(_this.reportCriteria);
                }
                var _a;
            });
        }
        else if (this.selectedProject.id === 0) {
            // in case create new project, when canceling new project, should set the first project as default
            if (this.listProjectOfAdvertiser.length > 1) {
                this.reportCriteria.project_id = this.listProjectOfAdvertiser[1].id;
                // generate the default report by the default project id
                this.generateReportByCriteria(this.reportCriteria);
            }
        }
        this.statusBottomBar = 'inactive';
    };
    MeasureComponent.prototype.fulfillCriteria = function (rawCriteria) {
        var criteria = new MeasureSearchCriteria();
        criteria.company_id = this.userService.getCompanyId();
        criteria.channel = rawCriteria.channel || 0;
        criteria.blog_id = rawCriteria.blog_id || 0;
        criteria.influencerGroup = rawCriteria.influencerGroup || 0;
        if (rawCriteria.project_id > 0) {
            criteria.project_id = rawCriteria.project_id;
        }
        else if (rawCriteria.campaign_id > 0) {
            criteria.project_id = rawCriteria.campaign_id;
        }
        else {
            criteria.project_id = 0;
        }
        criteria.date = rawCriteria.date || CommonConstant.DAYS_OF_WEEK;
        criteria.mention = rawCriteria.mention || 0;
        criteria.page_no = rawCriteria.page_no || CommonConstant.START_PAGE_INDEX;
        criteria.country_id = rawCriteria.country_id || 0;
        criteria.period = rawCriteria.period;
        criteria.orderBy = rawCriteria.orderBy;
        return criteria;
    };
    MeasureComponent.prototype.buildPeriodInfo = function () {
        if (!this.reportCriteria || !this.reportCriteria.period) {
            return '';
        }
        var endDate = this.reportCriteria.period.formattedEndDate;
        var startDate = this.reportCriteria.period.formattedStartDate;
        var startDateStr = DateUtils.formatDate(startDate.toString(), { day: 'numeric', month: 'short' }, CommonConstant.US_LOCALE);
        var endDateStr = DateUtils.formatDate(endDate.toString(), { day: 'numeric', month: 'short' }, CommonConstant.US_LOCALE);
        var year = endDate.getFullYear();
        return startDateStr + " - " + endDateStr + ", " + year;
    };
    MeasureComponent.prototype.isValidCriteriaToGenerateReport = function (criteria) {
        // only trigger report generation when have at least a selection
        var hasSelectedProject = (criteria.project_id !== undefined && criteria.project_id != null) ||
            (criteria.campaign_id !== undefined && criteria.campaign_id != null);
        var selectProject = this.listProjectOfAdvertiser.find(function (p) { return p.id === criteria.project_id; });
        this.selectedProjectWithoutMention = selectProject && selectProject.projectKeywords.length === 0;
        var hasSelectedGroup = criteria.influencerGroup !== undefined && criteria.influencerGroup != null;
        var hasSelectedChannel = criteria.channel !== undefined && criteria.channel != null;
        return this.selectedReport !== undefined &&
            this.reportCriteria !== undefined &&
            !this.selectedProjectWithoutMention &&
            (hasSelectedProject ||
                hasSelectedGroup ||
                hasSelectedChannel);
    };
    MeasureComponent.prototype.generateReportBySection = function (section, criteria) {
        var _this = this;
        switch (section) {
            case ReportSectionEnum.ROI_REPORT:
                this.roiReportSubscription = this.measureService.getRoiReportData(criteria).subscribe(function (res) {
                    _this.updateReportData(ReportSectionEnum.ROI_REPORT, res);
                }, function (error) {
                    _this.updateReadyReportModule(ReportSectionEnum.ROI_REPORT);
                });
                break;
            case ReportSectionEnum.TIMELINE_REPORT:
                this.performanceTimelineReportSubscription = this.measureService.getPerformanceTimeline(criteria)
                    .subscribe(function (res) {
                    _this.updateReportData(ReportSectionEnum.TIMELINE_REPORT, res, 'measure.performance_timeline');
                }, function (error) {
                    _this.updateReadyReportModule(ReportSectionEnum.TIMELINE_REPORT);
                });
                break;
            case ReportSectionEnum.KPI_REPORT:
                this.performanceGlobalKPIReportSubscription = this.measureService.getPerformanceGlobalKPIsFromEs(criteria)
                    .subscribe(function (res) {
                    _this.updateReportData(ReportSectionEnum.KPI_REPORT, res);
                }, function (error) {
                    _this.updateReadyReportModule(ReportSectionEnum.KPI_REPORT);
                });
                break;
            case ReportSectionEnum.LOCAL_AREAS_REPORT:
                this.marketDrillDownReportSubscription = this.measureService.getPerformanceLocalAreas(criteria)
                    .subscribe(function (res) {
                    _this.updateReportData(ReportSectionEnum.LOCAL_AREAS_REPORT, res);
                }, function (error) {
                    _this.updateReadyReportModule(ReportSectionEnum.LOCAL_AREAS_REPORT);
                });
                break;
            case ReportSectionEnum.MENTION_TIMELINE_REPORT:
                this.mentionTimelineReportSubscription = this.measureService.getPerformanceMentionTimeLineChart(criteria)
                    .subscribe(function (res) {
                    _this.updateReportData(ReportSectionEnum.MENTION_TIMELINE_REPORT, res.data.data, 'measure.mention_timeline');
                }, function (error) {
                    _this.updateReadyReportModule(ReportSectionEnum.MENTION_TIMELINE_REPORT);
                });
                break;
            case ReportSectionEnum.EXPOSURE_KPI_REPORT:
                this.exposureKPIReportSubscription = this.measureService.getExposureGlobalKPIs(criteria)
                    .subscribe(function (res) {
                    _this.updateReportData(ReportSectionEnum.EXPOSURE_KPI_REPORT, res);
                }, function (error) {
                    _this.updateReadyReportModule(ReportSectionEnum.EXPOSURE_KPI_REPORT);
                });
                break;
            case ReportSectionEnum.BEST_EXPOSURE_REPORT:
                this.bestPerformanceExposuresReportSubscription = this.measureService.getExposuresReport(criteria)
                    .subscribe(function (res) {
                    _this.updateReportData(ReportSectionEnum.BEST_EXPOSURE_REPORT, {
                        topExposure: _this.isValidExposureData(res.exposures) ? [
                            res.exposures.reach,
                            res.exposures.engagement,
                            res.exposures.impact
                        ] : [],
                        bestPerformanceExposures: res.bestPreformingExposures.contents
                    });
                }, function (error) {
                    _this.updateReadyReportModule(ReportSectionEnum.BEST_EXPOSURE_REPORT);
                });
                break;
            case ReportSectionEnum.EXPOSURE_PLATFORM_REPORT:
                this.platformReachSubscription = this.measureService.getPlatformReachReportData(criteria).subscribe(function (res) {
                    _this.updateReportData(ReportSectionEnum.EXPOSURE_PLATFORM_REPORT, res);
                }, function (error) {
                    _this.updateReadyReportModule(ReportSectionEnum.EXPOSURE_PLATFORM_REPORT);
                });
                break;
            case ReportSectionEnum.INSIGHT_BENCHMARK_REPORT:
                this.benchmarkPerformanceReportSubscription = this.measureService.getInsightBenchmarkPerformance(criteria)
                    .subscribe(function (res) {
                    _this.updateReportData(ReportSectionEnum.INSIGHT_BENCHMARK_REPORT, res.benchmarkPerformance, 'measure.benchmark_performance');
                }, function (error) {
                    _this.updateReadyReportModule(ReportSectionEnum.INSIGHT_BENCHMARK_REPORT);
                });
                break;
            case ReportSectionEnum.INTERACTION_REPORT:
                this.interactionReportSubscription = this.measureService.getInfluencerPostInteractionsFromES(criteria, this.numberOfPostInInteractionPdf)
                    .subscribe(function (res) {
                    _this.updateReportData(ReportSectionEnum.INTERACTION_REPORT, res, 'measure.interactions.interactions');
                }, function (error) {
                    _this.updateReadyReportModule(ReportSectionEnum.INTERACTION_REPORT);
                });
                break;
            // TODO not implemented yet API
            case ReportSectionEnum.INSIGHT_OPPORTUNITY_REPORT:
                this.insightOpportunityReportSubscription = this.measureService.getInsightChannelOpportunity(criteria)
                    .subscribe(function (res) {
                    _this.updateReportData(ReportSectionEnum.INSIGHT_OPPORTUNITY_REPORT, res.channelOpportunity, 'measure.channel_opportunity');
                }, function (error) {
                    _this.updateReadyReportModule(ReportSectionEnum.INSIGHT_OPPORTUNITY_REPORT);
                });
                break;
            case ReportSectionEnum.SEGMENTATION_INFLUENCER_OVERVIEW_REPORT:
                this.segmentInfluencerOverviewSubscription = this.measureService.getSegmentInfluencer(criteria)
                    .subscribe(function (res) {
                    _this.updateReportData(ReportSectionEnum.SEGMENTATION_INFLUENCER_OVERVIEW_REPORT, res, 'measure.influencer_overview');
                }, function (error) {
                    _this.updateReadyReportModule(ReportSectionEnum.SEGMENTATION_INFLUENCER_OVERVIEW_REPORT);
                });
                break;
            case ReportSectionEnum.SEGMENTATION_SEGMENT_REPORT:
                this.topicDrillDownReportSubscription = this.measureService.getSegmentTopics(criteria)
                    .subscribe(function (res) {
                    var reportData = res;
                    if (_this.removedTopicInsights) {
                        reportData = Object.assign({}, res, {
                            removeTopics: _this.removedTopicInsights
                        });
                    }
                    _this.updateReportData(ReportSectionEnum.SEGMENTATION_SEGMENT_REPORT, reportData, 'measure.segments');
                }, function (error) {
                    _this.updateReadyReportModule(ReportSectionEnum.SEGMENTATION_SEGMENT_REPORT);
                });
                break;
            case ReportSectionEnum.SEGMENTATION_INDUSTRY_REPORT:
                this.segmentIndustryReportSubscription = this.measureService.loadSegmentIndutries(criteria).subscribe(function (res) {
                    _this.updateReportData(ReportSectionEnum.SEGMENTATION_INDUSTRY_REPORT, res);
                }, function (error) {
                    _this.updateReadyReportModule(ReportSectionEnum.SEGMENTATION_INDUSTRY_REPORT);
                });
                break;
            // TODO not implemeted API yet
            case ReportSectionEnum.BEST_PERFORMING_INFLUENCER_REPORT:
                this.bestPerformingReportSubscription = this.measureService.getBestPerformingInfluencersFromES(criteria).subscribe(function (res) {
                    _this.bestPerformingReportDataForReach = res.data;
                    _this.updateReportData(ReportSectionEnum.BEST_PERFORMING_INFLUENCER_REPORT, _this.bestPerformingReportDataForReach, 'measure.best_performing_influencers');
                }, function (error) {
                    _this.updateReadyReportModule(ReportSectionEnum.BEST_PERFORMING_INFLUENCER_REPORT);
                });
                criteria.orderBy = BestPerformingInfluencerSortBy.ENGAGEMENT;
                this.bestPerformingReportForEngagementSubscription = this.measureService.getBestPerformingInfluencersFromES(criteria).subscribe(function (res) {
                    _this.bestPerformingReportDataForEngagement = res.data;
                });
                break;
            case ReportSectionEnum.OONA_REPORT:
                this.oonaReportSubscription = this.measureService.loadOONAReportData(criteria, this.numberOfPostInOnnaPdf).subscribe(function (res) {
                    _this.updateReportData(ReportSectionEnum.OONA_REPORT, res, 'measure.oona');
                }, function (error) {
                    _this.updateReadyReportModule(ReportSectionEnum.OONA_REPORT);
                });
                break;
        }
    };
    MeasureComponent.prototype.findTheMaximunPositionOfModule = function (report) {
        var maxPos = 1;
        if (!report) {
            return maxPos;
        }
        report.sectionList.forEach(function (section) {
            if (section.position > maxPos) {
                maxPos = section.position;
            }
        });
        return maxPos + 1;
    };
    MeasureComponent.prototype.isExistingModule = function (report, module) {
        if (!report) {
            return true;
        }
        return report.sectionList.filter(function (section) { return section.id === module.id; }).length > 0;
    };
    MeasureComponent.prototype.isValidExposureData = function (exposureData) {
        return exposureData && (exposureData.engagement.influencer_id || exposureData.reach.influencer_id || exposureData.impact.influencer_id);
    };
    /**
     * Everytime when user select an existing report. The data of previous report should be clear
     */
    MeasureComponent.prototype.resetReportData = function () {
        // discard previous report data
        this.reportData = {};
    };
    /**
     * Everytime when user select an existing report or change the criteria.
     * All pending HTTP request should be canceled;
     */
    MeasureComponent.prototype.cancelPendingRequest = function () {
        if (this.roiReportSubscription) {
            this.roiReportSubscription.unsubscribe();
        }
        if (this.performanceTimelineReportSubscription) {
            this.performanceTimelineReportSubscription.unsubscribe();
        }
        if (this.performanceGlobalKPIReportSubscription) {
            this.performanceGlobalKPIReportSubscription.unsubscribe();
        }
        if (this.marketDrillDownReportSubscription) {
            this.marketDrillDownReportSubscription.unsubscribe();
        }
        if (this.mentionTimelineReportSubscription) {
            this.mentionTimelineReportSubscription.unsubscribe();
        }
        if (this.exposureKPIReportSubscription) {
            this.exposureKPIReportSubscription.unsubscribe();
        }
        if (this.topExposuresReportSubscription) {
            this.topExposuresReportSubscription.unsubscribe();
        }
        if (this.bestPerformanceExposuresReportSubscription) {
            this.bestPerformanceExposuresReportSubscription.unsubscribe();
        }
        if (this.benchmarkPerformanceReportSubscription) {
            this.benchmarkPerformanceReportSubscription.unsubscribe();
        }
        if (this.interactionReportSubscription) {
            this.interactionReportSubscription.unsubscribe();
        }
        if (this.insightOpportunityReportSubscription) {
            this.insightOpportunityReportSubscription.unsubscribe();
        }
        if (this.segmentIndustryReportSubscription) {
            this.segmentIndustryReportSubscription.unsubscribe();
        }
        if (this.segmentInfluencerOverviewSubscription) {
            this.segmentInfluencerOverviewSubscription.unsubscribe();
        }
        if (this.platformReachSubscription) {
            this.platformReachSubscription.unsubscribe();
        }
        if (this.bestPerformingReportSubscription) {
            this.bestPerformingReportSubscription.unsubscribe();
        }
        if (this.bestPerformingReportForEngagementSubscription) {
            this.bestPerformingReportForEngagementSubscription.unsubscribe();
        }
    };
    MeasureComponent.prototype.buildReportList = function (existsingReports, selectedReportId, reloadContent) {
        var listExistingReport = [];
        // reset selected report
        this.selectedReport = undefined;
        // if default report is not null and belonged to current account, then choose it as default
        if (selectedReportId !== undefined) {
            this.selectedReport = existsingReports.find(function (report) { return report.id === selectedReportId; });
            this.updateSupportLink(this.reportCriteria);
        }
        // if no default or default is not belonged to current account, choose the first one in list
        if (!this.selectedReport) {
            // reset the default report
            this.initializeCriteria.reportId = null;
            if (existsingReports[0]) {
                this.selectedReport = existsingReports[0];
            }
            else {
                this.selectedReport = new Report();
            }
        }
        // retrieved list selected module Ids
        if (this.selectedReport) {
            this.selectedModuleIds = this.selectedReport.sectionList.map(function (section) { return section.id; });
            this.buildListModuleForPdf();
        }
        // track event with Segment
        if (this.listProjectOfAdvertiser.length > 1 && this.selectedReport && this.selectedReport.id > 0) {
            this.viewReportTracker(this.selectedReport, this.listProjectOfAdvertiser[1]);
        }
        if (reloadContent && (!this.userService.isFreeUser() || this.userService.isAdmin)) {
            // rebuild report content
            this.generateReportByCriteria(this.reportCriteria);
        }
        listExistingReport.push.apply(listExistingReport, existsingReports);
        return listExistingReport;
    };
    MeasureComponent.prototype.buildListModuleForPdf = function () {
        var _this = this;
        this.listModuleForPdf = ObjectUtils.deepClone(this.selectedModuleIds);
        this.selectedModuleIds.forEach(function (sm) {
            if (sm === ReportSectionEnum.ROI_REPORT && _this.numberOfPostInRoiPdf) {
                var roiPdfPages = _this.calculatePageForPdf(_this.numberOfPostInRoiPdf, ReportSectionEnum.ROI_REPORT);
                _this.duplicateModulePdf(roiPdfPages, ReportSectionEnum.ROI_REPORT);
            }
            if (sm === ReportSectionEnum.OONA_REPORT && _this.numberOfPostInOnnaPdf) {
                var oonaPdfPages = _this.calculatePageForPdf(_this.numberOfPostInOnnaPdf, ReportSectionEnum.OONA_REPORT);
                _this.duplicateModulePdf(oonaPdfPages, ReportSectionEnum.OONA_REPORT);
            }
            if (sm === ReportSectionEnum.INTERACTION_REPORT && _this.numberOfPostInInteractionPdf) {
                var interactionPdfPages = _this.calculatePageForPdf(_this.numberOfPostInInteractionPdf, ReportSectionEnum.INTERACTION_REPORT);
                _this.duplicateModulePdf(interactionPdfPages, ReportSectionEnum.INTERACTION_REPORT);
            }
        });
    };
    MeasureComponent.prototype.duplicateModulePdf = function (numOfPage, moduleId) {
        var moduleIndex = this.listModuleForPdf.findIndex(function (sm) { return sm === moduleId; });
        if (moduleIndex >= 0) {
            for (var i = 1; i < numOfPage; i++) {
                this.listModuleForPdf.splice(moduleIndex + i, 0, moduleId);
                this.updateComponentIndexMapping(moduleId, moduleIndex + i, i);
            }
        }
    };
    MeasureComponent.prototype.updateComponentIndexMapping = function (reportType, originalIndex, componentIndex) {
        switch (reportType) {
            case ReportSectionEnum.ROI_REPORT:
                this.roiIndexMapping.set(originalIndex, componentIndex);
                break;
            case ReportSectionEnum.OONA_REPORT:
                this.oonaIndexMapping.set(originalIndex, componentIndex);
                break;
            case ReportSectionEnum.INTERACTION_REPORT:
                this.interactionIndexMapping.set(originalIndex, componentIndex);
                break;
        }
    };
    MeasureComponent.prototype.updateReportData = function (section, data, titleKey) {
        Object.defineProperty(this.reportData, section, {
            value: {
                title: titleKey ? this.translate.instant(titleKey) : undefined,
                data: data
            },
            writable: false
        });
        this.updateReadyReportModule(section);
    };
    MeasureComponent.prototype.updateReadyReportModule = function (section) {
        if (this.moduleArr.indexOf(section) < 0) {
            this.moduleArr.push(section);
        }
    };
    MeasureComponent.prototype.getDefaultDateRange = function () {
        var today = DateUtils.now();
        var toDate = NgbDateUtils.convertNgbDate(today);
        var daysBackward = DateUtils.addPerid(today, -MeasureReportTimeline.A_MONTH);
        var fromDate = NgbDateUtils.convertNgbDate(daysBackward);
        return DateRange.buildDateRangeWithBorder(fromDate, toDate);
    };
    MeasureComponent.prototype.onFilterShowChange = function (isFilterShow) {
        this.isFilterShow = isFilterShow;
    };
    MeasureComponent.prototype.onReportDataChange = function (data) {
        var mergedCriteria = Object.assign({}, this.reportCriteria, data.criteriaChange);
        mergedCriteria.project_id = this.reportCriteria.project_id;
        mergedCriteria = this.fulfillCriteria(mergedCriteria);
        this.generateReportBySection(data.reportSection, mergedCriteria);
    };
    MeasureComponent.prototype.onReportSettingsChange = function (data) {
        switch (data.reportType) {
            case ReportSectionEnum.INSIGHT_BENCHMARK_REPORT:
                this.activeBenchmarkPerformance = data.value;
                break;
            case ReportSectionEnum.SEGMENTATION_SEGMENT_REPORT:
                this.removedTopicInsights = data.value;
                break;
            case ReportSectionEnum.INSIGHT_OPPORTUNITY_REPORT:
                this.activeChannelOpportunity = data.value;
                break;
        }
        this.updateSupportLink(this.reportCriteria);
    };
    MeasureComponent.prototype.exportCsv = function () {
        var projectId = this.reportCriteria.project_id || 0;
        if (this.reportCriteria.campaign_id) {
            projectId = this.reportCriteria.campaign_id;
        }
        var influencerGroupId = this.reportCriteria.influencerGroup || 0;
        // stop processing if there is no project or campaign or group has been selected
        if (projectId === 0 && influencerGroupId === 0) {
            this.showWarningNotification();
            return;
        }
        // show notification
        this.modalService.open(this.alertPdfDownloadPending, null, true, CommonConstant.PDF_EXPORT_NOTIFICATION_SHOWING_TIME);
        // call to server to export CSV file
        this.measureService.exportCSV(projectId, influencerGroupId, this.reportCriteria.period.startDate, this.reportCriteria.period.endDate).subscribe();
    };
    MeasureComponent.prototype.exportPdfReport = function (evt) {
        this.numberOfPostInInteractionPdf = evt.interactionPage;
        this.numberOfPostInOnnaPdf = evt.postEngagementPage;
        this.numberOfPostInRoiPdf = evt.roiPage;
        var companyId = this.userService.getCompanyId();
        var target = this.getTrackerReportCriteriaTarget(this.reportCriteria);
        this.downloadPDF();
    };
    MeasureComponent.prototype.downloadPDF = function () {
        var _this = this;
        // cancel previous request
        if (this.exportPdfSubcription) {
            this.exportPdfSubcription.unsubscribe();
        }
        this.modalService.open(this.alertPdfDownloadPending, null, true, CommonConstant.PDF_EXPORT_NOTIFICATION_SHOWING_TIME);
        var selectedProject = this.reportCriteria.project_id;
        var selectedCampaign = this.reportCriteria.campaign_id;
        var fulFillCriteria = this.fulfillCriteria(this.reportCriteria);
        var params = Object.assign({}, fulFillCriteria, {
            reportId: this.selectedReport.id,
            project_id: selectedProject || 0,
            campaign_id: selectedCampaign || 0,
            period: null,
            date: null,
            from: fulFillCriteria.period ? fulFillCriteria.period.startDate : null,
            to: fulFillCriteria.period ? fulFillCriteria.period.endDate : null,
            benchmark_posts: this.numberOfPostInOnnaPdf,
            interaction_posts: this.numberOfPostInInteractionPdf,
            roi_posts: this.numberOfPostInRoiPdf,
            removed_ti: this.removedTopicInsights ? this.removedTopicInsights.join(',') : null
        });
        if (this.activeBenchmarkPerformance) {
            params = Object.assign({}, params, {
                active_bp: this.activeBenchmarkPerformance
            });
        }
        if (this.activeChannelOpportunity) {
            params = Object.assign({}, params, {
                active_co: this.activeChannelOpportunity
            });
        }
        this.exportPdfSubcription = this.pdfViewerService.generateMeasurePdf(params, this.userService.getCompanyId())
            .subscribe(function (res) {
            // track event by segment
            var target = _this.getTrackerReportCriteriaTarget(_this.reportCriteria);
            _this.eventTracker.trackUserAction(UserActionType.ACTION, Page.REPORT, {
                id: target.targetId,
                name: target.targetName,
                type: target.targetType
            }, {
                action: UserActionType.EXPORT,
                source: ActionSource.BOTTOM_BAR,
            }, {
                id: _this.selectedReport.id,
                name: _this.selectedReport.name
            }, {
                type: ActivePages.MEASURE,
                name: _this.selectedReport.name,
                id: _this.selectedReport.id
            }, {
                report_from: _this.reportCriteria.period.startDate,
                report_to: _this.reportCriteria.period.endDate
            });
        });
    };
    MeasureComponent.prototype.closeExportingPopup = function (evt) {
        if (this.measureExporting) {
            this.measureExporting.isSelectedPostCount = false;
        }
    };
    Object.defineProperty(MeasureComponent.prototype, "logoImage", {
        get: function () {
            return this.userService.logoImage;
        },
        enumerable: true,
        configurable: true
    });
    MeasureComponent.prototype.viewReportTracker = function (report, project) {
        if (!project || !report) {
            return;
        }
        // track report view action to Segment
        this.trackMeasureView(report, this.reportCriteria);
    };
    Object.defineProperty(MeasureComponent.prototype, "activePage", {
        get: function () {
            return {
                type: ActivePages.MEASURE
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureComponent.prototype, "isFreeUser", {
        get: function () {
            return this.userService.isFreeUser();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureComponent.prototype, "shouldDisableFreemiumFeature", {
        get: function () {
            return this.isFreeUser && !this.userService.isAdmin;
        },
        enumerable: true,
        configurable: true
    });
    MeasureComponent.prototype.measureContextData = function (contextType) {
        if (!this.selectedReport) {
            return null;
        }
        var data = {
            action: UserActionType.ACTION,
            item: Page.REPORT,
            params: {
                action: contextType === 'create' ? UserActionType.CREATE : UserActionType.UPDATE,
                source: ActionSource.PAGE
            },
        };
        if (contextType !== 'create') {
            data = Object.assign({}, data, {
                report: {
                    id: this.selectedReport.id,
                    name: this.selectedReport.name
                }
            });
        }
        return data;
    };
    Object.defineProperty(MeasureComponent.prototype, "canActivateModuleDropdown", {
        get: function () {
            return this.moduleList && this.moduleList.length > 0 && this.selectedReport;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureComponent.prototype, "maxPageOfPostEngagement", {
        get: function () {
            var postEngagement = this.getReportDataById(ReportSectionEnum.OONA_REPORT);
            return postEngagement ? this.roundPageCount(postEngagement.totalCount) : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureComponent.prototype, "maxPageOfRoi", {
        get: function () {
            var roiData = this.getReportDataById(ReportSectionEnum.ROI_REPORT);
            return roiData ? this.roundPageCount(roiData.totalRow) : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureComponent.prototype, "maxPageOfInteraction", {
        get: function () {
            var interactionData = this.getReportDataById(ReportSectionEnum.INTERACTION_REPORT);
            return interactionData ? this.roundPageCount(interactionData.totalRows) : null;
        },
        enumerable: true,
        configurable: true
    });
    MeasureComponent.prototype.showAlertWhenModifyingDefaultReport = function () {
        this.modalService.open(this.notificationWarningEditDefaultReport, undefined, true);
    };
    MeasureComponent.prototype.openExportingModulePopup = function () {
        if (this.moduleArr.length !== this.selectedModuleIds.length) {
            return;
        }
        var currentState = this.showExportingModule;
        if (currentState) {
            this.closeExportingModulePopup();
        }
        else {
            this.showExportingModule = true;
        }
    };
    MeasureComponent.prototype.closeExportingModulePopup = function () {
        if (this.measureExporting) {
            this.measureExporting.isSelectedPostCount = false;
        }
        this.showExportingModule = false;
    };
    MeasureComponent.prototype.onCLickOutsidePopup = function (evt) {
        if (evt.target.classList.contains('export-button')) {
            evt.preventDefault();
            return;
        }
        this.closeExportingModulePopup();
    };
    MeasureComponent.prototype.roundPageCount = function (itemCount) {
        var normalizeTotalItem = Math.min(itemCount, CommonConstant.MAX_ITEM_ALLOWED_BY_PDF);
        return normalizeTotalItem;
    };
    MeasureComponent.prototype.calculatePageForPdf = function (pageCount, module) {
        var normalizeTotalPage = Math.min(pageCount, CommonConstant.MAX_ITEM_ALLOWED_BY_PDF);
        var totalFullPage;
        var hasPartialPage;
        switch (module) {
            case ReportSectionEnum.ROI_REPORT:
                totalFullPage = Math.floor((normalizeTotalPage + 2) / CommonConstant.MAX_ROI_ITEM_IN_PDF_PAGE);
                hasPartialPage = ((normalizeTotalPage + 2) % CommonConstant.MAX_ROI_ITEM_IN_PDF_PAGE) > 0;
                break;
            case ReportSectionEnum.OONA_REPORT:
                totalFullPage = Math.floor(normalizeTotalPage / CommonConstant.MAX_OONA_ITEM_IN_PDF_PAGE);
                hasPartialPage = (normalizeTotalPage % CommonConstant.MAX_OONA_ITEM_IN_PDF_PAGE) > 0;
                break;
            case ReportSectionEnum.INTERACTION_REPORT:
                totalFullPage = Math.floor((normalizeTotalPage + 2) / CommonConstant.MAX_INTERACTION_ITEM_IN_PDF_PAGE);
                hasPartialPage = ((normalizeTotalPage + 2) % CommonConstant.MAX_INTERACTION_ITEM_IN_PDF_PAGE) > 0;
                break;
        }
        return hasPartialPage ? totalFullPage + 1 : totalFullPage;
    };
    MeasureComponent.prototype.onSelectBestPerformingInfluencerSorting = function (evt) {
        this.reportCriteria.orderBy = evt;
        this.selectedBestPerformingInfluencerOrder = evt;
        // update link
        this.updateSupportLink(this.reportCriteria);
        // cancel all pending request
        this.cancelPendingRequest();
        // check the validation of criteria
        if (!this.isValidCriteriaToGenerateReport(this.reportCriteria)) {
            // criteria invalid because report is not loaded yet. Don't need to report Sentry
            if (!this.selectedReport) {
                return;
            }
            this.showWarningNotification();
            // Report to Sentry
            Sentry.captureException(new Error(this.notificationContent));
            // stop generating if the no filter or no selected report
            return;
        }
        if (evt === BestPerformingInfluencerSortBy.REACH) {
            this.updateReportData(ReportSectionEnum.BEST_PERFORMING_INFLUENCER_REPORT, this.bestPerformingReportDataForReach, 'measure.best_performing_influencers');
        }
        else {
            this.updateReportData(ReportSectionEnum.BEST_PERFORMING_INFLUENCER_REPORT, this.bestPerformingReportDataForEngagement, 'measure.best_performing_influencers');
        }
    };
    Object.defineProperty(MeasureComponent.prototype, "disableExportButton", {
        get: function () {
            return this.moduleArr.length !== this.selectedModuleIds.length;
        },
        enumerable: true,
        configurable: true
    });
    return MeasureComponent;
}(AbstractAchooComponent));
export { MeasureComponent };



// WEBPACK FOOTER //
// ./src/app/main/measure/measure.component.ts.pre-build-optimizer.js